import React, { useMemo, useState } from 'react';
import {Card, CardBody, Col, Row} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
import { Link } from "theme-ui";
import { Tooltip } from "@mui/material";
import { formatDate } from "src/utils/DateUtils";
import Badge from "react-bootstrap/Badge";

const RiderWiseOrderTableView = ({ reactTableData,isNoRecordFound }) => {
  const [rows] = useState(reactTableData);
  const { t } = useTranslation('common');
 

  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by First Name,username, emailid...',
  };

  const handleLinkClick = (orderId, orderNo) => {
    // setOrderNo(orderNo)
    // setOrderId(orderId);
    // setStatusProgress(true);

};
  const columns = useMemo(
    () => [
        {
            Header: '#',
            accessor: 'id',
            disableGlobalFilter: true,
            width: 65,
        },


        {
            Header: 'Tracking No',
            accessor: 'orderNumber',
            Cell: row => (
                <div className="icon-style" >
                    <Tooltip title="Click here to view the Order Status">
                        <Link to={`/order-status/${row.original?.orderId}`} onClick={() => handleLinkClick(row.row.original?.orderId, row.row.original?.orderNo)}>
                            {row.row.original?.orderNo}
                        </Link>
                    </Tooltip>
                </div>
            ),
        },
        {
            Header: 'Invoice No.',
            accessor: 'invoiceNo',
            disableGlobalFilter: true,
        },
        {
            Header: 'Ecom Order No.',
            accessor: 'salesOrderNo',
            disableGlobalFilter: false,
        },
        // {
        //   Header: 'Merchant Name',
        //   accessor: 'merchantInfo.merchantName',
        //   disableGlobalFilter: false,
        // },
        {
            Header: 'Customer Name',
            accessor: 'name',
            disableGlobalFilter: false,
        },

        {
            Header: 'Order Date Time',
            accessor: 'createdDateTime',
            Cell: ({ value }) => formatDate(value),  // Use the utility function
            disableGlobalFilter: false,
        },
        {
            Header: 'Order Requested Date',
            accessor: 'requestedDateTimeSlot',
            Cell: ({ value }) => value ? formatDate(value) : '',  // Use the utility function
            disableGlobalFilter: false,
        },



        {
            Header: 'Order Status',
            accessor: 'orderStatusInfo.orderStatusDes',
            disableGlobalFilter: false,
        },



        {
            Header: "Order Type",
            accessor: "orderType",
            disableSortBy: false,
            width: 20,
            Cell: ({ row }) => (
                <>
                    {row.original.orderType === 1 ? (
                        <h6><Badge bg="success">DROP OFF</Badge></h6>
                    ) : row.original.orderType === 2 ? (
                        <h6><Badge bg="primary">PICK UP</Badge></h6>
                    ) : (
                        <h6><Badge bg="warning">PnD</Badge></h6>
                    )}
                </>
            )
        },

    ],
    [],
);
  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <Row>
            <Col md={12}>
              <h3 className="page-title">Current Order List</h3>
            </Col>
          </Row>
               
         { !isNoRecordFound ?<ReactTableBase
            name={t('instution_type.modify.name_map')}
            key={'searchable'}
            columns={columns}
            data={rows}
            tableConfig={tableConfig}
          />:
          <h3>No Record Found</h3>
           
         }

        </CardBody>
      </Card>
    </Col>
  );
};

export default RiderWiseOrderTableView;

